import { createLocalStorageProvider } from '@jira/platform__browser-storage-providers/src/controllers/local-storage/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const storage = createLocalStorageProvider('jsm-insight-reports-assets-deeplinking-modal');

/** Persisted flag: `false` after the user dismisses the onboarding modal; absent means show once. */
const MODAL_OPEN_STORAGE_KEY = 'modalOpen';

/** Initial visibility: `false` in local storage means the user already dismissed the onboarding modal. */
export const readAssetsDeeplinkingModalShouldShow = (): boolean => {
	const stored = storage.get(MODAL_OPEN_STORAGE_KEY);
	return stored !== false;
};

export const persistAssetsDeeplinkingModalClosed = (): void => {
	if ('setStrictlyNecessaryItem' in storage && fg('jfp-vulcan-browser-storage-migration')) {
		// @browser-storage setter
		storage.setStrictlyNecessaryItem(MODAL_OPEN_STORAGE_KEY, false);
		return;
	}
	// @browser-storage setter
	storage.set(MODAL_OPEN_STORAGE_KEY, false);
};
